export const xxs = '0';
export const xs = '24em';
export const s = '32em';
export const m = '48em';
export const l = '64em';
export const xl = '80em';
export const xxl = '100em';

export interface Breakpoints {
  xxs: string;
  xs: string;
  s: string;
  m: string;
  l: string;
  xl: string;
  xxl: string;
}

export function makeBelow(val: string): string {
  return `not all and (min-width: ${val})`;
}

export function makeOrAbove(val: string): string {
  return `all and (min-width: ${val})`;
}
export const breakpoints = { xs, s, m, l, xl, xxl };
export const orAbove = Object.keys(breakpoints).reduce(
  (ret, key) => ({ ...ret, [key]: makeOrAbove(breakpoints[key]) }),
  {} as Breakpoints
);
export const below = Object.keys(breakpoints).reduce(
  (ret, key) => ({ ...ret, [key]: makeBelow(breakpoints[key]) }),
  {} as Breakpoints
);
